import {
  SET_ERROR_LIST_FOR_SHARED
} from './constants';

export const setErrorList = errors => ({
  type: SET_ERROR_LIST_FOR_SHARED,
  payload: errors
});



// WEBPACK FOOTER //
// ./src/features/shared/error/actionTypes.js